var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 52.6667C48.512 52.6725 47.067 53.1668 45.8872 54.0738C44.7074 54.9808 43.8581 56.2502 43.47 57.6868C43.0818 59.1234 43.1762 60.6478 43.7388 62.0255C44.3013 63.4032 45.3007 64.5581 46.5834 65.3125V75H53.5001V65.3125C54.515 64.7122 55.3572 63.8595 55.945 62.8373C56.5327 61.8151 56.846 60.6582 56.8543 59.4792V59.4792C56.8543 58.581 56.6767 57.6917 56.3317 56.8625C55.9868 56.0332 55.4812 55.2804 54.8442 54.6472C54.2072 54.0141 53.4513 53.5131 52.6199 53.1732C51.7886 52.8333 50.8982 52.6612 50.0001 52.6667V52.6667Z",
    stroke: "#3F3F95",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6042 37.0208H24.375C19.4044 37.0208 15.375 41.0503 15.375 46.0208V81.625C15.375 86.5956 19.4044 90.625 24.375 90.625H75.6042C80.5747 90.625 84.6042 86.5956 84.6042 81.625V46.0208C84.6042 41.0503 80.5747 37.0208 75.6042 37.0208Z",
    stroke: "#3F3F95",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8125 37.0208V31.5833C27.8125 25.6933 30.1523 20.0445 34.3172 15.8797C38.482 11.7148 44.1308 9.375 50.0208 9.375C55.9108 9.375 61.5596 11.7148 65.7245 15.8797C69.8894 20.0445 72.2292 25.6933 72.2292 31.5833V37.0208",
    stroke: "#3F3F95",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d0f42c119ba3ba2c1e20a2d4b3264a46.svg";
export { ForwardRef as ReactComponent };